module.exports = __webpack_public_path__ + "img/tx2.9768718f.png";